import uuid from 'react-uuid';

import { ApolloLink } from '@apollo/client';

import { getAppVersion, getToken, setOperationUuid } from '@utils/localStorage';
import { getAppKey, getDeviceKey } from '@utils/device';
import { getSessionKey } from '@utils/session';

const RefreshMiddleware = new ApolloLink((operation, forward) => {
  const apolloToken = getToken();
  const sessionUuid = getSessionKey();
  const operationUuid = uuid();
  setOperationUuid(operationUuid);
  const device = getDeviceKey();
  const appVersion = getAppVersion();
  const appKey = getAppKey();
  const parsedVersion = appVersion ? appVersion.replaceAll('"', '') : appVersion;

  operation.setContext(({ headers = {} }) => ({
    headers: {
      ...headers,
      authorization: apolloToken || null,
      'X-Device': device,
      'X-App': appKey,
      'X-Version': parsedVersion,
      'X-Correlation-ID': operationUuid,
      'X-Session-ID': sessionUuid,
    },
  }));

  return forward(operation);
});

export default RefreshMiddleware;
